import React, { memo, useState } from 'react';

interface ModelResponseSelectorTabsWrapperProps {
  className?: string;
  children: (props: {
    tab: ModelResponseSelectorTab;
    setTab: (tab: ModelResponseSelectorTab) => void;
    stacked: boolean;
    setStacked: (stacked: boolean) => void;
  }) => React.ReactNode;
}

export enum ModelResponseSelectorTab {
  Markdown = 'markdown',
  Diff = 'diff',
}

const ModelResponseSelectorTabsWrapper: React.FC<ModelResponseSelectorTabsWrapperProps> = memo(
  props => {
    const { className, children } = props;
    const [tab, setTab] = useState<ModelResponseSelectorTab>(ModelResponseSelectorTab.Markdown);
    const [stacked, setStacked] = useState<boolean>(false);
    return <div className={className}>{children({ tab, setTab, stacked, setStacked })}</div>;
  },
);

ModelResponseSelectorTabsWrapper.displayName = 'ModelResponseSelectorTabsWrapper';

export default ModelResponseSelectorTabsWrapper;
